import React, { useState } from 'react';
import { Menu } from 'antd';
import { Layout, Tabs } from 'antd';

interface MenuItem {
    name: string;
    link: string;
}

export const SideMenu: React.FC = () => {
    const menuItems: MenuItem[] = [
        {
            name: 'Кубик-Рубика',
            link: '../kubik/index.html'
        },
        {
            name: 'Пятнашки',
            link: '../pyatnashki/pyatnashki.html'
        },
        {
            name: 'Крестики-нолики',
            link: '../TicTacToe/index.html'
        },
        {
            name: 'Редактор шаблонов страницы',
            link: '../templator/index.html'
        }
    ];

    return (
        <React.Fragment>
            <Tabs tabPosition="left">
                {menuItems.map((menuItem, index) => (
                    <Tabs.TabPane key={menuItem.name} tab={menuItem.name}>
                        <iframe src={menuItem.link} style={{ width: '100%', height: '99.5vh', border: 'none' }} />
                    </Tabs.TabPane>
                ))}
            </Tabs>
        </React.Fragment>
    )
}